import React from "react";
import { Route, Redirect } from "react-router-dom";

const SalesRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        var role = localStorage.getItem("role");
        if (role === "admin" || role === "salesman") {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/my-deals",
                state: {
                  from: props.location
                }
              }}
            />
          );
        }
      }}
    />
  );
};

export default SalesRoute;
